import * as React from "react";

import type {GqlFetchFn} from "@khanacademy/wonder-blocks-data";

import type {GqlContextRecord} from "./types.ts";

interface GqlRouterContextData {
    /**
     * The Wonder Blocks Data-compatible gqlFetch function to use for
     * Wonder Blocks Data-based GQL operations.
     */
    fetch: GqlFetchFn<any, any, GqlContextRecord> | null | undefined;
}

export const GqlRouterContext: React.Context<GqlRouterContextData> =
    React.createContext<GqlRouterContextData>({
        fetch: null,
    });
GqlRouterContext.displayName = "GqlRouterContext";
